import 'bootstrap';
import ready, { HTML } from 'Utils';
import initContactForm from './components/contactForm';
import initSubscribeModal from './components/modalSubscribe';
import dropdownTouchFix from './components/dropdownTouchFix.js';
import initCustomDropdown from './components/initCustomDropdown.js';
import toggleVeteranMode from './components/toggleVeteranMode.js';
import initBlogFilter from './components/initBlogFilter.js';
import initCustomPriceDropdown from './components/initCustomPriceDropdown.js';
import initBook from './components/book/index.js';
import './customerlabs-tracking.js'; // CustomerLabs tracking
import initGuaranteeQuiz from './components/guarantee-quiz';

ready(() => {
    HTML.classList.add('is-loaded');

    // Bootstrap автоматично ініціалізує компоненти через data-bs-toggle атрибути
    // Просто слухаємо події для додавання класу 'open'
    const accordions = document.querySelectorAll('.accordion-collapse');

    if (accordions.length > 0) {
        accordions.forEach((collapseEl) => {
            collapseEl.addEventListener('show.bs.collapse', function () {
                collapseEl.closest('.accordion-item')?.classList.add('open');
            });

            collapseEl.addEventListener('hide.bs.collapse', function () {
                collapseEl.closest('.accordion-item')?.classList.remove('open');
            });

            if (collapseEl.classList.contains('show')) {
                collapseEl.closest('.accordion-item')?.classList.add('open');
            }
        });
    }

    initContactForm();
    initSubscribeModal();
    dropdownTouchFix();
    toggleVeteranMode();
    initBlogFilter();
    initBook('.book', {});

    const dropdownInstance = initCustomDropdown('.hero__btns');
    const getValue = initCustomPriceDropdown('#prices');

    document.querySelectorAll('.blog__filters .dropdown').forEach(drop => {
        const btn = drop.querySelector('.dropdown-toggle');
        const items = drop.querySelectorAll('.dropdown-item');
        items.forEach(item => item.addEventListener('click', e => {
            e.preventDefault();

            items.forEach(i => i.classList.remove('selected'));
            item.classList.add('selected');

            btn.textContent = item.textContent;
        }));
    });
  initGuaranteeQuiz();
});

document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById('searchInput');
    const clearBtn = document.getElementById('clearBtn');

    if (input && clearBtn) {
        input.addEventListener('input', () => {
            clearBtn.style.display = input.value ? 'block' : 'none';
        });

        clearBtn.addEventListener('click', () => {
            input.value = '';
            clearBtn.style.display = 'none';
            input.focus();
        });
    }
});
